/* eslint-disable */

import { useState } from "react";
import { HiX } from "react-icons/hi";
import { FiLogOut } from "react-icons/fi";
import Links from "./components/Links";
import LogoutConfirmationModal from "components/modal/LogoutConfirmationModal";
import routes from "routes.js";
import Logo from "../../assets/img/logo.png";
import avatar from "assets/img/avatars/avatar4.png";

const Sidebar = ({ open, onClose }) => {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  
  const socialStorageString = localStorage.getItem("social-storage");
  const socialStorage = JSON.parse(socialStorageString || "{}");

  const handleLogOutClick = () => {
    setIsLogoutModalOpen(true);
  };

  const handleLogOut = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleCloseModal = () => {
    setIsLogoutModalOpen(false);
  };

  return (
    <div
      className={`sm:none duration-300 linear fixed !z-50 flex min-h-full w-[300px] flex-col !bg-[#192242] pb-10 text-white transition-all md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`ml-[32px] mr-[64px] my-6 flex items-center`}>
        <div className="mt-1 flex gap-2 font-poppins font-bold uppercase text-white">
          <img src={Logo} alt="Logo" className="h-[40px] w-[40px]" />{" "}
          <p className="text-[26px]">Be Social</p>
        </div>
      </div>
      <div class="mb-7 h-px bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <Links routes={routes} onLinkClick={onClose} />
      </ul>

      {/* Free Horizon Card */}
      {/* <div className="flex justify-center">
        <SidebarCard />
      </div> */}

      {/* Profile Section */}
      <div className="mt-auto px-8 py-4 pb-7">
        {/* Profile Image and Name - Show only on small mobile screens, hide on larger mobile and desktop */}
        {/* <div className="flex items-center gap-3 mb-4 md:hidden">
          <img
            src={avatar}
            alt="Profile"
            className="h-10 w-10 rounded-full flex-shrink-0"
          />
          <p className="text-sm font-medium text-white truncate">
            {socialStorage?.username || "Admin"}
          </p>
        </div> */}
        {/* Logout Button - Always visible */}
        <button
          onClick={handleLogOutClick}
          className="flex w-full items-center justify-start gap-2 rounded-lg bg-red-500/20 px-4 py-0.5 text-lg  text-red-400 transition-colors hover:bg-red-500/30"
        >
          <FiLogOut className="h-4 w-4" />
          Logout
        </button>
      </div>

      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal
        isOpen={isLogoutModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleLogOut}
      />

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
